import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=5b271133&scoped=true"
import script from "./FileSystem.vue?vue&type=script&lang=js"
export * from "./FileSystem.vue?vue&type=script&lang=js"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=5b271133&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.8__ejs@3.1.10_loda_tabtodhn2upniikejzvtfgbz5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b271133",
  null
  
)

export default component.exports